import { useEffect, useState } from 'react'
import { devicesService } from '../../../services/devicesService'

export interface DeviceTeamData {
  deviceTeams: Record<number, number | null>
  onlineTeamIds: Set<number>
}

const EMPTY: DeviceTeamData = { deviceTeams: {}, onlineTeamIds: new Set() }

export function useDeviceTeams(propertyId: number | undefined): DeviceTeamData {
  const [data, setData] = useState<DeviceTeamData>(EMPTY)

  useEffect(() => {
    if (propertyId == null) {
      setData(EMPTY)
      return
    }
    let cancelled = false

    devicesService
      .getAll(propertyId)
      .then((devices) => {
        if (cancelled) return
        const deviceTeams: Record<number, number | null> = {}
        const onlineTeamIds = new Set<number>()
        for (const device of devices) {
          const teamId = device.team_id ?? null
          deviceTeams[device.id] = teamId
          if (device.is_online && teamId !== null) onlineTeamIds.add(teamId)
        }
        setData({ deviceTeams, onlineTeamIds })
      })
      .catch(() => {
        if (!cancelled) setData(EMPTY)
      })

    return () => {
      cancelled = true
    }
  }, [propertyId])

  return data
}
